import { makeStyles } from '@mui/styles';

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
  },
  AppBar: {
    backgroundColor: 'transparent',
    background: 'transparent',
  },
  menuButton: {
    marginRight: theme.spacing(2),
  },
  title: {
    fontSize: 14,
    lineHeight: 14,
  },
  media: {
    width: 103,
    height: 60,
  },
  cube: {
    width: 24,
    height: 22,
  },
  order: {
    // background: 'rgba(255, 255, 255, 0.11)',
    width: 164,
    height: 62,
    cursor: 'pointer',
  },
  profile: {
    fontSize: 12,
    lineHeight: '138 %',
    letterSpacing: '0.0075em',
    color: '#B3E5FB',
  },
  searchInput: {
    background: '#FFFFFF',
  },
  notched: {
    border: 'none',
  },
  badge: {
    backgroundColor: '#00B894',
    color: '#FFF',
    padding: 0,
  },
  label: {
    font: 'normal normal 600 12px Montserrat',
    color: '#AFB0B2',
  },
}));

export default useStyles;
